<template>
    <main class="qtime-main">
        <div id="ddd"></div>
        <modal @proceed="onClickYes" @close="onClickClose" v-if="showModal">
            <!--
              you can use custom content here to overwrite
              default content
            -->
            <h3 slot="header">Are you sure you want to delete ?</h3>
        </modal>
        <release-modal
                @proceedRelease="onReleaseYes"
                @closeRelease="onClickClose"
                v-if="showReleaseModal"
        >
            <h3 slot="header">Are you sure you want to release ?</h3>
        </release-modal>
        <modal @proceed="onClickListYes" @close="onClickClose" v-if="showDeleteListModal">
            <h3 slot="header">Are you sure you want to delete selected entries ?</h3>
        </modal>
        <modal @proceed="onChangeDateYes" @close="onClickCancel" v-if="showChangeDateModal">
            <h3 slot="header">There are changes pending to be saved. Are you sure to switch date ?</h3>
        </modal>
        <modal @proceed="onContinueSaveYes" @close="onClickCloseContinueSaveModal" v-if="showContinueSaveModal">
            <h3 slot="header">You have not recorded enough hours. Continue to Save ?</h3>
        </modal>
        <save-denied-modal @back="onClickBack" v-if="showSaveDeniedModal">
            <h3 slot="header">You cannot record absence hours more than target hours</h3>
        </save-denied-modal>
        <save-denied-modal @back="onClickBackOverlap" v-if="overlapSaveDeniedModal">
            <h3 slot="header">Time entries overlap, please correct before saving</h3>
        </save-denied-modal>
        <modal @proceed="reloadData" @close="onClickReloadClose" v-if="showReload">
            <h3 slot="header">Failed to load entries. Try again ?</h3>
        </modal>
        <save-denied-modal @back="onClickTimeLimit" v-if="timelimitSaveDeniedModal">
            <h3 slot="header">The allocated number of hours for this position has been used. Please contact the Delivery Manager in case more time is needed.</h3>
        </save-denied-modal>
        <div class="container" id="con" :class="(!isToday) || (!released && checkedCount > 0) || (checkedCount > 0)?'header-expand': ''">

         

            <div class="filter-sec">
                   <!-- newly added for mobile responsive sec  -->
            <div class="progress-info" v-if="!released">
                <span data-v-767281b6="" v-if="updatedData" class="progress-tag"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                                    color: #757575;
                                ">Updated</span>

                <span data-v-767281b6=""  v-if="noOverlapMessage" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">Time entries overlap, please correct before saving</span>
                
                <span data-v-767281b6=""  v-if="absenceHrGreaterMsg" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">You cannot record absence hours more than target hours</span>
                
                <span data-v-767281b6=""  v-if="twentyFourHourGreaterMsg" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                                    color: #757575;">You cannot record more than 24 hours</span>

                <span data-v-767281b6="" v-if="errorSave" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;
                ">There was an error while saving the data</span>

                <span data-v-767281b6="" href="" class="progress-tag" v-if="inProgress"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;
                ">In progress</span>

                <span data-v-767281b6=""  v-if="noTimeLimitMessage" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">The allocated number of hours for this position has been used. Please contact the Delivery Manager in case more time is needed.</span>

            </div>
                <div class="filter-date">
                    <div class="date-picker-arr" >
                        <a href class="filter-arrow left-arrow" @click.stop.prevent="gotoToPrevDate" :disabled="saveFlagValue">
                            <img src="../../assets/images/icons/left-arrow.png" alt/>
                        </a>
                        <div id="date-id-picker" class="date-picker date-picker-qtime">
                            <!-- <input type="text" class="filter-datepicker" value="Friday October 01, 2018" /> -->
                            <!-- <VueDatePicker attach-to="#date-id-picker" format="ddd, DD MMMM YYYY" v-model="date" @onChange="changeDate" no-header/> -->
                            
                            <date-picker format="ddd, DD MMMM YYYY" attach-to="#date-id-picker" :value="moment(date)" :allowClear="false" @change="changeDate" :showToday="false" >
                                <template slot="dateRender" slot-scope="current, selectedday">
                                    <div class="ant-calendar-date" :class="getCurrentStyle(current, selectedday)" >
                                        {{ current.date() }}
                                    </div>
                                </template>
                                <Icon type="none" slot="suffixIcon"/>
                            </date-picker>
                        </div>
                        <a href class="filter-arrow right-arrow" @click.stop.prevent="gotoToNextDate" :disabled="saveFlagValue">
                            <img src="../../assets/images/icons/right-arrow.png" alt/>
                        </a>
                    </div>
                    <a v-if="!isToday" @click.stop.prevent="gotoToToday" href class="today-select">Today</a>
                    <div v-if="checkedCount > 0" class="copy-btn-wrapper" id="copy-btn-wrapper">
                        <!-- <datepicker  ref="programaticOpen"> copy </datepicker> -->
                        <!-- <button  @click="openPicker">Open Picker</button> -->
                        <button type="button" id="date-id-copy" class="copy-btn">Copy</button>
                        <VueDatePicker attach-to="#date-id-copy" v-model="copyDate" @onChange="copyToDate" :range="true" validate no-header />

                        <!-- <date-picker attach-to="#copy-btn-wrapper" format="ddd, DD MMMM YYYY" id="date-copy-picker" :value="moment(copyDate)" :allowClear="false" @change="copyToDate" validate :showToday="false" >
                            <Icon type="none" slot="suffixIcon"/>
                        </date-picker> -->
                    </div>
                    <div v-if="!released && checkedCount > 0 && isLeave == 0" class="copy-btn-wrapper">
                        <button type="button" id="id-delete" class="copy-btn" @click.stop.prevent="deleteListClick">
                            Delete
                        </button>
                    </div>
                </div>
                <div class="work-hours">
                    <p>
                        <img src="../../assets/images/icons/target-icon.png" alt/>
                        Target Hours: {{totalOEHoursText}} Hrs.
                    </p>
                    <p>
                        <img src="../../assets/images/icons/time-icon.png" alt/>
                        Actual Hours:
                        <span v-if="parseFloat(this.totalHours.replace(',','.')) >= totalOEHours" style="color:#5ca43c !important">{{totalHours}}</span>
                        <span v-else-if="parseFloat(this.totalHours.replace(',','.')) == 0" style="color:#aa0b48 !important">{{totalHours}}</span>
                        <span v-else style="color:#da6a09 !important">{{totalHours}}</span>
                    </p>
                </div>
            </div>
            <div class="Qtime_table-wrapper">
                <div class="Qtime-table">
                    <div class="table-head">
                        <div class="table-row table-row-header">
                            <div class="col booking-node">
                                <div class="custom-checkbox"  >
                                     <input type="checkbox" class="clear-checkbox" @change="checkBoxClicked" v-model="allChecked"/>
                                    <label for class="custom-checkbox-label"></label>
                                </div>
                                <p>Booking Node</p>
                            </div>
                            <div class="col position">
                                <p>Position</p>
                            </div>
                            <div class="col actual-hours">
                                <p>Actual Hours</p>
                            </div>
                            <div class="col from">
                                <p>From</p>
                            </div>
                            <div class="col to">
                                <p>To</p>
                            </div>
                            <div class="description col">
                                <p>Description</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-bar> -->
                    <div>
                        <div class="table" id="Qtime-table_main">
                            <template v-for="(item, index) in timeData">
                                <times @clicked="onClickChild" @timeChanged="calculateTotalHours()" @descriptionChanged="DescriptionChanged(item.id)" @timeValueChanged="TimeValueChanged(item.id)" :item="item" :key="item.uuid||item.id||item.parentPinnedId"
                                       :index="index" :error="error"/>
                                       {{ item.released === false ? setReleasedFlag(false) : null }}
                                       {{ item.actualTime === null && !item.pinned ? setHideOtherLine(true): null}}
                            </template>
                        </div>
                    </div>
                
                  
                    <div v-if="!released || !releasedFlag || monthUnreleasedFlag" class="addmore-row">
                        <div v-if="!releasedLatestHide">
                            
                            <p :class="{ 'btn-disabled': hideAnotherLine }" @click.stop.prevent="addAnother">
                                 <img src="../../assets/images/icons/plus-icon.png" alt/> Add another line
                            </p>
                        </div>
                        <!-- <div v-if="pinnedBool">
                            <p @click.stop.prevent="addAnother">
                                 <img src="../../assets/images/icons/plus-icon.png" alt/> Add another line
                            </p>
                        </div> -->
                    </div>
                </div>
            </div>
            <div v-if="!released || !releasedFlag || monthUnreleasedFlag" class="cta_btn-wrapper">
                <div v-if="!releasedLatestHide">
                <!--<a
                        v-if="timeData.length > 0"
                        href
                        class="cta-btn save-btn"
                        @click.stop.prevent="saveAll"
                >Save</a>-->

                <!-- active class if it is active -->
                <a href class="cta-btn release-btn" @click.stop.prevent="validateAll">Release</a>

                <span data-v-767281b6="" v-if="updatedData" class="progress-tag"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;
                ">Updated</span>

                <span data-v-767281b6=""  v-if="noOverlapMessage" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">Time entries overlap, please correct before saving</span>

                
                <span data-v-767281b6=""  v-if="absenceHrGreaterMsg" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">You cannot record absence hours more than target hours</span>

                <span data-v-767281b6=""  v-if="twentyFourHourGreaterMsg" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                                    color: #757575;">You cannot record hours more than 24 hours</span>

                <span data-v-767281b6="" v-if="errorSave" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;
                ">There was an error while saving the data</span>

                <span data-v-767281b6="" href="" class="progress-tag" v-if="inProgress"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;
                ">In progress</span>

                <span data-v-767281b6=""  v-if="noTimeLimitMessage" class="progress-tag progress-cancelled"><img data-v-767281b6="" src="../../assets/images/icons/updated.png" alt="" style="
                    color: #757575;">The allocated number of hours for this position has been used. Please contact the Delivery Manager in case more time is needed.</span>

                <div class="validation-msg-bt">
                </div>

                 <div class="addmore-row ad-for-mobile">
                    <p @click.stop.prevent="addAnother">
                        <img src="../../assets/images/icons/plus-icon.png" alt/> Add another line
                    </p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    
    import {VueDatePicker} from "@mathieustan/vue-datepicker";
    import { DatePicker, Icon} from 'ant-design-vue';
    import 'ant-design-vue/es/date-picker/style/css';
    import moment from 'moment';

    const Times = () => import("./qtime/Times");
    const Modal = () => import("./qtime/DeleteModal");
    const ReleaseModal = () => import("./qtime/ReleaseModal");
    const SaveDeniedModal = () => import("./qtime/SaveDeniedModal");
    import $ from "jquery";

    export default {
        name: "Qtime",
        data() {
            return {
                error: false,
                releasedFlag: true,
                showModal: false,
                releasedLatestHide: false,
                showDeleteListModal: false,
                showReleaseModal: false,
                showChangeDateModal: false,
                showContinueSaveModal: false,
                showSaveDeniedModal: false,
                overlapSaveDeniedModal: false,
                timelimitSaveDeniedModal: false,
                timeIitemId: null,
                timeindex: null,
                copyDate: new Date(),
                allChecked: false,
                currDate: this.$store.state.qtime.currentDate,
                todayStr: (new Date()).toLocaleString('en-GB').slice(0, 10),
                totalHours: "00:00",
                showReload: false,
                enableoverlapmsg:false,
                enabletimelimitmsg:false,
                enableAbscmsg:false,
                enabletwentyfourmsg:false,
                overlapError:false,
                pinnedBool : false,
                currentMonth: true
            };
        },
        computed: {
            date: {
                set: function (value) {
                    this.$store.commit("setCurrentDate", value);
                },
                get: function () {
                    return this.$store.state.qtime.currentDate;
                }
            },
            timeData: function () {
                this.enabletimelimitmsg = false;
                this.releasedLatestHide = false;
                this.enabletwentyfourmsg = false;
                this.$store.dispatch('updateHideAnotherLine', false);
                return this.$store.state.qtime.timeEntries;
            },
            hideAnotherLine: function () {
                return this.$store.state.qtime.hideAnotherLine;
            },
            timeDataClone: function () {
                return this.$store.state.qtime.timeEntriesClone;
            },
            internalPositionData: function () {
                return this.$store.state.qtime.internalPositionTimes;
            },
            monthUnreleasedFlag: function(){
                return this.$store.state.qtime.monthUnreleased[0].flag === 0 ? false : true;
            },
            positionData: function () {
                return this.$store.state.qtime.positions;
            },
            bookingNodeData: function () {
                return this.$store.state.qtime.bookingNodes;
            },
            totalOEHours: function () {
                return this.$store.state.qtime.details ? this.$store.state.qtime.details.workingHoursCountryBased : 0;
            },
            totalOEHoursText: function () {
                return this.$store.state.qtime.details ? this.$store.state.qtime.details.workingHoursCountryBased.toFixed(2).toString().replace(".", ",") : 0;
            },
            checkedCount: function () {
                return this.$store.state.qtime.selectedRows ? this.$store.state.qtime.selectedRows.length : 0;
            },
            released: function () {
                return this.$store.state.qtime.released;
            },
            isToday: function () {
                return this.todayStr === this.date.toLocaleString('en-GB').slice(0, 10);
            },
            noOverlapMessage:function(){
                 return this.enableoverlapmsg;
            },
            absenceHrGreaterMsg:function(){
                return this.enableAbscmsg;
            },
            twentyFourHourGreaterMsg:function(){
                return this.enabletwentyfourmsg;
            },
            updatedData:function(){
                return this.$store.state.forecast.globalUpdate;
            },
            errorSaving:function(){
                 return this.enableErrorIcon;
            },
            inProgress:function(){
                return this.$store.state.forecast.globalProgress;
            },
            errorSave:function(){
                return this.$store.state.forecast.globalerrorSave;
            },
            monthlyData: function () {
                return this.$store.state.qtime.monthlyData;
            },
            weekendId: function () {
                return this.$store.state.qtime.details ? this.$store.state.qtime.details.weekendId : null;
            },
            partimeDays: function () {
                return this.$store.state.qtime.partimeDays;
            },
            saveFlagValue:function(){
                return this.$store.state.qtime.saveFlag;
            },
            noTimeLimitMessage:function(){
                return this.enabletimelimitmsg;
            },
            isLeave: function () {
                var count = 0;
                
                this.$store.state.qtime.selectedRows.filter((id,index) => 
                { 
                    var timeEntry =  this.$store.state.qtime.timeEntries.filter((time,index) => 
                                    {
                                        if(time.id == id && time.podioRequestId > 0){
                                            count++;
                                        }
                                    
                                    });
                });
                return count;
            }
        },
        components: {
            Times,
            VueDatePicker,
            Modal,
            ReleaseModal,
            SaveDeniedModal,
            DatePicker,
            Icon
        },
        destroyed() {
            document.body.classList.remove('qtime-body');
        },
        methods: {
            reset() {
                this.releasedFlag = true
            },
            consolethis(value){
                console.log(value);
            },
            /**
             * Init all api requests
             */
             setReleasedFlag(value) {
                this.releasedFlag = value;
            },
            setHideOtherLine(value) {
                this.$store.dispatch('updateHideAnotherLine', value);
            },
            setPinnedValue(value){
                this.pinnedBool = value;
            },
            moment,
            getCurrentStyle (current, selectedday) {
                
                var today = new Date();
                let style = "";
                
                if(current.month() != selectedday._i.getMonth() || current.year() != selectedday._i.getFullYear())
                {
                    if(this.weekendId == null || this.weekendId == 2)
                    {
                        if(current.day() == 0 || current.day() == 6)
                        {
                            style = "date-grey-box";
                        }
                    }
                    else{
                        if(current.day() == 5 || current.day() == 6)
                        {
                            style = "date-grey-box";
                        }
                    }
                    //// To colour grey for the part time days
                    if(this.partimeDays != null && this.partimeDays.length > 0)
                    {
                        this.partimeDays.filter( function(value) {
                            if(value.Day == current.day() + 1)
                            {
                                style = "date-grey-box";
                            }
                        });
                    }
                }
                else{
                
                    if(current.date() == 15)
                    {
                        if(current.month() == selectedday._i.getMonth() && current.year() == selectedday._i.getFullYear())
                        {
                            this.currentMonth = true;
                        }
                        else
                        {
                            this.currentMonth = false;
                            $(".date-orange-box").removeClass("date-orange-box");
                            $(".date-grey-box").removeClass("date-grey-box");
                            $(".date-green-box").removeClass("date-green-box");
                            $(".date-blue-box").removeClass("date-blue-box");
                        }
                    }
                        
                    if(this.currentMonth)
                    {
                        if(selectedday.month() == current.month() && selectedday.year() == current.year()){
                            
                            if(selectedday.date() == current.date()){
                                style = "date-blue-box";
                            }
                            else {

                                let data = this.monthlyData.filter(x => x.date === current.date());                        

                                if(data.length > 0)
                                {
                                    if(data[0].actualHour == null)
                                    {
                                        data[0].actualHour = "00:00:00";
                                    }

                                    let splitValue = data[0].actualHour.split(":");
                                    let firstVal = parseFloat(splitValue[0]);
                                    let hours = parseFloat(splitValue[1]/60)  + parseFloat(splitValue[2]/3600);
                                    let actualValue = firstVal + hours;
                                    
                                    if(data[0].tragetHour == 0)
                                    {
                                        style = "date-grey-box";
                                    }
                                    else if(actualValue == 0)
                                    {
                                        style = "";
                                    }
                                    else if(data[0].tragetHour <= actualValue)
                                    {
                                        style = "date-green-box";
                                    }
                                    else
                                    {
                                        style = "date-orange-box";
                                    }
                                }
                            }
                        }
                    }                               
                }

                return style;
            },
            requestApis: function () {
                // fetch the forecast data
                this.$store.dispatch("setGlobalLoaderInitial", false);
                this.$store.dispatch("fetchQTime").then(response => {
                    this.$store.dispatch("setGlobalLoaderInitialfalse", false); 
                    if(!response) {this.showReload = true;
                     }
                 }, error => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again", error);
                    this.showReload = true;
                });
                
            },
            unreleasedMonth: function () {
                this.$store.dispatch("unreleasedMonth").then(response => {
                    if(!response) {this.showReload = true; }
                 }, error => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again", error);
                    this.showReload = true;
                });
            },
            internalPositionTimes: function () {
                this.$store.dispatch("internalPositionTimes").then(response => {
                    if(!response) {this.showReload = true; }
                 }, error => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again", error);
                    this.showReload = true;
                });
            },
            addAnother: function () {
                this.$store.commit("addAnotherTimeRow");
            },
            changeDate: function (value, dateString) {
                this.reset();
                if(dateString != undefined && value != undefined)
                {
                    this.date = value._d;
                }
                this.error=false;
                if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)) this.showChangeDateModal = true;
                else this.onChangeDateYes();
            },
            copyToDate: function () {
                this.reset();
                this.$store.dispatch("copyToDate", this.copyDate).then(
                    () => {
                        this.date = this.copyDate.end;
                        this.changeDate();
                        this.copyDate = new Date();
                    }
                )
            },
            deleteListClick: function () {
                this.showDeleteListModal = true;
            },
            onClickListYes: function () {
                this.$store.dispatch("deleteListFromDb").then(
                    () => {
                        this.showDeleteListModal = false;
                        this.requestApis();
                    }
                )
            },
            saveAll: function (currentItemId) {
                let validData = true;
                this.enableoverlapmsg = false;
                this.enableAbscmsg = false;
                let total = "00:00:00";
                let absenceNodeIds = this.bookingNodeData.filter(node => node.bookingNode.startsWith("Sickness") || 
                                        node.bookingNode.startsWith("Vacation") || node.bookingNode.startsWith("Sonstiges") || node.bookingNode.startsWith("Spare Time")).map(x => x.itemId);

                let vacOrSickNodeIds = this.bookingNodeData.filter(node => node.bookingNode.startsWith("Sickness") || 
                                        node.bookingNode.startsWith("Vacation")).map(x => x.itemId);

                this.unreleasedMonth();
                this.internalPositionTimes();
                var overTimeFlag = false;
                let excludeTimeEntryIds = [];

                this.timeData.forEach(element => {
                    let totalTimeSum=0;
                    if (!element.bookingId || !element.positionId) validData = false;
                    else if(!element.actualTime && !element.pinned) validData = false;
                    else {
                        let positionDetails = this.positionData.find(x => x.itemId === element.positionId);
                        
                        if (absenceNodeIds.includes(element.bookingId) && element.totalTime != null && element.totalTime.indexOf(":") !== -1) {
                            let timeToAddArr = element.totalTime.split(":");
                            let ms = (60 * 60 * parseInt(timeToAddArr[0]) + 60 * (parseInt(timeToAddArr[1])) + parseInt(timeToAddArr[2])) * 1000;
                            //let newTime = new Date('1970-01-01T' + total).getTime() + ms;
                            let dateFormat = '1970-01-01T' + total;
                            let newTime = new Date(dateFormat.replace(/-/g, '/').replace('T', ' ')).getTime() + ms;
                            let finalTime = new Date(newTime).toTimeString().substring(0, 8);
                            total = finalTime;
                        }
                        if(element.pinned)
                        {   
                            if(absenceNodeIds.includes(element.bookingId)){
                                validData=false;
                            }

                            else if(element.actualTime || element.from || element.to || element.description){
                                 if((element.actualTime) || (element.from && element.to))
                                {
                                    //converting date format for pin entries-for timezone difference
                                    if(element.id==undefined || element.id==0)
                                    {
                                        let dateModifiedpin = element.date;
                                        if(typeof(dateModifiedpin)!="string")
                                        {
                                            element.date=dateModifiedpin.toDateString();
                                        }
                                    
                                    }
                                    if (positionDetails.description === "Mandatory" && !element.description) validData = false;
                                    else if (positionDetails.actualHours === "Mandatory" && !element.actualTime) validData = false;
                                    else if (positionDetails.fromTo === "Mandatory" && !element.from) validData = false;
                                    else if (positionDetails.fromTo === "Mandatory" && !element.to) validData = false;
                                    else
                                    return;
                                }
                                else
                                {
                                    validData=false;
                                }
                            }           
                            
                        }

                            /*    //converting date format for pin entries or newly created item-for timezone difference
                            if(element.id==undefined || element.id==0)
                            {
                                let dateModified = element.date;
                                if(typeof(dateModified)!="string")
                                {
                                    element.date=dateModified.toDateString();
                                }
                            }*/

                            //converting date format for pin entries or newly created item-for timezone difference
                            if(element.id==undefined || element.id==0)
                            {
                             var isInternalPositionData = this.positionData.find(x => x.itemId === element.positionId &&  x.isInternal == true);
                                if (isInternalPositionData) {
                                    var aInMillis = new Date('1970-01-01T' + element.totalTime + 'Z').getTime();
                                    
                                    // convert b to milliseconds
                                    var bInMillis = isInternalPositionData.totalHours * 60 * 60 * 1000;

                                    // add the two times together and convert to hours
                                    var totalTimeAdded = (aInMillis + bInMillis) / (60 * 60 * 1000);

                                    if (totalTimeAdded <= isInternalPositionData.maxAllowedHours || isInternalPositionData.maxAllowedHours === null) {
                                        this.enabletimelimitmsg = false;
                                    }
                                    else if (isInternalPositionData.totalHours === element.totalTime) {
                                        this.enabletimelimitmsg = false;
                                    }
                                    else {
                                        this.enabletimelimitmsg = true;
                                    }
                                }
                                let dateModified = element.date;
                                if(typeof(dateModified)!="string")
                                {
                                    element.date=dateModified.toDateString();
                                }
                                /*
                                if (positionDetails.positionTitle.toLowerCase().includes("sick")) validData = false;
                                if (positionDetails.positionTitle.toLowerCase().includes("vacation")) validData = false;
                                */

                                if (positionDetails.positionTitle.toLowerCase().includes("sick") || vacOrSickNodeIds.includes(positionDetails.bookingNode)) {
                                    validData = false;
                                }
                                if (positionDetails.positionTitle.toLowerCase().includes("vacation") || vacOrSickNodeIds.includes(positionDetails.bookingNode)) {
                                    validData = false;
                                }
                            }
                            
                            else{
                                
                                var isInternalPositionData = this.positionData.find(x => x.itemId === element.positionId && x.isInternal == true);
                                if (isInternalPositionData) {
                                    console.log(this.internalPositionData)
                                    const positionTimeEntries = this.internalPositionData.filter(obj =>
                                        obj.PositionId === element.positionId
                                        );
                                    if(positionTimeEntries){
                                        positionTimeEntries.forEach(timedata => {
                                            if(timedata.Id === element.id){
                                                if(timedata.TotalTime != element.totalTime){
                                                    var inMillis = new Date('1970-01-01T' + element.totalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum+inMillis;
                                                }
                                                else{
                                                    var inMillis = new Date('1970-01-01T' + timedata.TotalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum+inMillis;
                                                }
                                            }
                                            else{
                                                var inMillis = new Date('1970-01-01T' + timedata.TotalTime + 'Z').getTime();
                                                totalTimeSum = totalTimeSum+inMillis;
                                            }
                                        })
                                        /*
                                        if(element.id === this.timeData[this.timeData.length - 1].id){
                                                    var inMillis = new Date('1970-01-01T' + element.totalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum + inMillis;
                                                }
                                        */
                                        var actualTime = totalTimeSum / (60 * 60 * 1000);
                                        if(actualTime > isInternalPositionData.maxAllowedHours){
                                            excludeTimeEntryIds.push(element.id);

                                        }
                                        
                                    }
                                }
                                
                            }
                            
                            if (positionDetails.description === "Mandatory" && !element.description && !element.pinned) validData = false;
                            else if (positionDetails.actualHours === "Mandatory" && !element.actualTime && !element.pinned) validData = false;
                            else if (positionDetails.fromTo === "Mandatory" && !element.from && !element.pinned) validData = false;
                            else if (positionDetails.fromTo === "Mandatory" && !element.to && !element.pinned) validData = false;
                            /*
                            else if (positionDetails.positionTitle.toLowerCase().includes("sick")) validData = false;
                            else if (positionDetails.positionTitle.toLowerCase().includes("vacation")) validData = false;
                            */
                            if (positionDetails.positionTitle.toLowerCase().includes("sick") || vacOrSickNodeIds.includes(positionDetails.bookingNode)) {
                                    validData = false;
                            }
                            if (positionDetails.positionTitle.toLowerCase().includes("vacation") || vacOrSickNodeIds.includes(positionDetails.bookingNode)) {
                                    validData = false;
                            }
                    }
                });

                if(currentItemId !== undefined){
                    let totalTimeSum=0;
                    let currentSavingItem = this.timeData.find(x=>x.id == currentItemId);

                    if(currentSavingItem !== null || currentSavingItem !== undefined || currentSavingItem.id > 0){
                        var isInternalPositionData = this.positionData.find(x => x.itemId === currentSavingItem.positionId && x.isInternal == true);
                                if (isInternalPositionData) {
                                    console.log(this.internalPositionData)
                                    const positionTimeEntries = this.internalPositionData.filter(obj =>
                                        obj.PositionId === currentSavingItem.positionId
                                        );
                                    if(positionTimeEntries){
                                        positionTimeEntries.forEach(timedata => {
                                            if(timedata.Id === currentSavingItem.id){
                                                if(timedata.TotalTime != currentSavingItem.totalTime){
                                                    var inMillis = new Date('1970-01-01T' + currentSavingItem.totalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum+inMillis;
                                                }
                                                else{
                                                    var inMillis = new Date('1970-01-01T' + timedata.TotalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum+inMillis;
                                                }
                                            }
                                            else{
                                                var inMillis = new Date('1970-01-01T' + timedata.TotalTime + 'Z').getTime();
                                                totalTimeSum = totalTimeSum+inMillis;
                                            }
                                        })
                                        /*
                                        if(currentSavingItem.id === this.timeData[this.timeData.length - 1].id){
                                                    var inMillis = new Date('1970-01-01T' + currentSavingItem.totalTime + 'Z').getTime();
                                                    totalTimeSum = totalTimeSum + inMillis;
                                                }
                                         */       
                                        var actualTime = totalTimeSum / (60 * 60 * 1000);
                                        if(actualTime > isInternalPositionData.maxAllowedHours){
                                            overTimeFlag = true;
                                        }
                                        
                                    }
                                }
                    }
                }

                if(overTimeFlag){
                    this.enabletimelimitmsg = true;
                }
                if(validData && this.timeData.length > 1) {
                    validData = !this.multipleDateRangeOverlaps(this.timeData);
                }

                if (validData) {
                    console.log(excludeTimeEntryIds);
                    this.error=false;
                     let decValue = parseFloat(this.totalHours.replace(",","."));
                    if(isNaN(decValue)){
                        this.enabletwentyfourmsg = true;
                    }
                     else{
                        let actualMoment = moment(new Date(2020, 4, 2, 0, 0, decValue * 3600));
                        let targetMoment = moment(new Date(2020, 4, 2, 0, 0, this.totalOEHours * 3600));

                        //let absenceMoment = moment('2020-05-02T'+total);
                        let absenceMoment = '2020-05-02T'+total;
                        let newAbscTime = new Date(absenceMoment.replace(/-/g, '/').replace('T', ' ')).getTime();

                        if (newAbscTime > targetMoment) {this.enableAbscmsg = true; this.$store.state.forecast.globalUpdate = false;}//this.showSaveDeniedModal = true;
                        else {
                            //if (actualMoment < targetMoment) this.showContinueSaveModal = true;
                            //else 
                            if(!this.enabletimelimitmsg){
                                if(!this.enabletwentyfourmsg){
                                    if(excludeTimeEntryIds !== undefined){
                                        //this.$store.state.qtime.timeEntries = this.$store.state.qtime.timeEntries.filter(timeEntry => !excludeTimeEntryIds.includes(timeEntry.id));

                                    }

                                    this.saveToDb(excludeTimeEntryIds);
                                    this.enabletimelimitmsg = false;
                                    this.enabletwentyfourmsg = false;
                                    this.$store.dispatch('updateHideAnotherLine', false);
                                }
                                
                            }
                        
                        }
                     }

                } else {
                    this.error = true;
                }
            },
            gotoToToday: function () {
                this.reset();
                this.date = new Date();
                this.changeDate();
            },
            gotoToNextDate: function () {
                this.reset();
                this.currDate = new Date(this.date);
                let currDate = this.date;
                this.date = new Date(currDate.setDate(currDate.getDate() + 1));
                this.changeDate();
                this.unreleasedMonth();
            },
            gotoToPrevDate: function () {
                this.reset();
                this.currDate = new Date(this.date);
                let currDate = this.date;
                this.date = new Date(currDate.setDate(currDate.getDate() - 1));
                this.changeDate();
                this.unreleasedMonth();
            },
            onClickChild: function (itemId, index) {
                this.showModal = !this.showModal;
                this.timeIitemId = itemId;
                this.timeindex = index;
            },
            onClickClose: function () {
                this.showModal = false;
                this.showReleaseModal = false;
                this.timeIitemId = null;
                this.timeindex = null;
                this.showDeleteListModal = false;
            },
            onClickCancel: function () {
                this.date = this.currDate;
                this.showChangeDateModal = false;
            },
            onClickCloseContinueSaveModal: function () {   
                this.showContinueSaveModal = false;
            },
            onClickBack: function () {
                this.showSaveDeniedModal = false;
            },
            onClickBackOverlap: function () {
                this.overlapSaveDeniedModal = false;
            },
            onClickTimeLimit: function () {
                this.timelimitSaveDeniedModal = false;
                this.enabletimelimitmsg = false;
            },
            onClickYes: function () {
                this.$store.dispatch("deleteFromDb", this.timeIitemId).then(
                    () => {
                        this.$store.commit("removeTimeEntry", this.timeindex);
                        this.showModal = false;
                        this.requestApis();
                    }
                )
            },
            onReleaseYes: function () {
                this.$store.dispatch("releaseAll", this.date).then(
                    () => {
                        this.$store.dispatch("fetchQTime").then(
                            () => {
                                this.showReleaseModal = false;
                                this.releasedLatestHide = true;
                            }
                        );
                    }
                    
                )
            },
            onChangeDateYes: function () {
                this.showChangeDateModal = false;
                //this.date = new Date(this.date);

                //if this.date is string format parse it to avoid timezone issue else pass it
                if(typeof(this.date)=="string")
                {
                    let dateArray = this.date.split('-');
                    this.date = new Date(dateArray[0],dateArray[1]-1,dateArray[2]);
                }

                this.$store.dispatch("goToDate", this.date).then(response => {
                    if(!response) { this.showReload = true; }
                 }, error => {
                    console.error("Got nothing from server. Prompt user to check internet connection and try again", error);
                    this.showReload = true;
                });
                this.unreleasedMonth();
            },
            onClickReloadClose: function () {
                this.showReload = false;
            },
            reloadData: function () {
                this.showReload = false;
                this.onChangeDateYes();
            },
            checkBoxClicked: function () {
                if (this.allChecked) {
                    this.$store.commit("checkAll");
                } else {
                    this.$store.commit("uncheckAll");
                }
            },
            validateAll: function () {
                this.$store.dispatch("validateRelease", this.date).then(
                    () => {
                        this.showReleaseModal = true;
                    }
                )
            },
            checkCalendarFn: function () {
                let i = 0;
                // executes only for few time
                if (document.querySelector('.datepicker') != undefined && document.querySelector('.datepicker') != null) {
                    if (document.querySelector('.date-picker-qtime') != undefined && document.querySelector('.date-picker-qtime') != null) {
                        var triggerElement = document.querySelector('.date-picker-qtime'),
                            triggerElementBound = triggerElement.getBoundingClientRect();
                        if (i <= 2) {
                            document.querySelector('.datepicker').style.left = triggerElementBound.left + "px";
                            i++;
                        }

                    }
                }
            },
            onContinueSaveYes: function () {
                this.saveToDb();
                this.showContinueSaveModal = false;
            },
            saveToDb: function (excludeTimeEntryIds) {
               this.$store.dispatch("saveToDb",excludeTimeEntryIds).then(() => {
                        this.$store.dispatch("fetchQTime");
                    });
                    this.enabletimelimitmsg = false;
            },
            calculateTotalHours: function (e) {
                let total = "00:00:00";
                let travelNode = this.bookingNodeData.find(x => x.bookingNode.startsWith("Travel Time"));
                let travelNodeId = (travelNode != null) ? travelNode.itemId : 0;
                let decTimeTotal = 0;
                let decTime=0;
                let negativePositions = this.positionData.filter(x => x.type === "Negative").map(y=>y.itemId)

                this.$store.state.qtime.timeEntries.forEach(element => {
                    if (element.actualTime != null && element.bookingId != null && travelNodeId != element.bookingId && element.totalTime != null && element.totalTime.indexOf(":") !== -1 
                    && !negativePositions.includes(element.positionId)) {
                        let timeToAddArr = element.totalTime.split(":");
                        let ms = (60 * 60 * parseInt(timeToAddArr[0]) + 60 * (parseInt(timeToAddArr[1])) + parseInt(timeToAddArr[2])) * 1000;
                        let dateFormat = '1970-01-01T' + total;
                        let newTime = new Date(dateFormat.replace(/-/g, '/').replace('T', ' ')).getTime() + ms;
                        let finalTime = new Date();
                        if(newTime > 23400000){
                            finalTime = new Date(newTime).toLocaleTimeString('en-US', { hour12: false }).substring(0, 8);
                            
                        }
                        else{
                            finalTime = new Date(newTime).toTimeString().substring(0, 8);
                            
                        }
                        let decimalTime = parseFloat(timeToAddArr[0]) + (parseFloat(timeToAddArr[1]) / 60) + (parseFloat(timeToAddArr[2]) / 3600);
                        decTimeTotal = decTimeTotal+decimalTime;
                        total = finalTime;
                    }
                });
                // this.enabletwentyfourmsg= false;
                if(decTimeTotal > 24.00){
                    this.enabletwentyfourmsg= true;
                }

                this.totalHours = this.timeConvert(total);
            },
            hourFromMins: function (num) {
                let hours = (num * 100 / 60);
                return hours > 0 ? hours.toString().replace(".","") : '00';
            },
            timeConvert: function (value) {
                 let splitValue = value.split(":");
                 let firstVal = parseFloat(splitValue[0]);
                 let hours = parseFloat(splitValue[1]/60)  + parseFloat(splitValue[2]/3600);
                 let actualValue = firstVal+hours;
               
                 return actualValue.toFixed(2).toString().replace(".",",");
            },
            DescriptionChanged:function(currentItemId){
               /*var d = new Date();
               this.descriptionChange = e+d.getSeconds();*/
               this.enableoverlapmsg = false;
                  this.enableAbscmsg = false;
                  this.enabletimelimitmsg = false;
                 setTimeout(() => this.$store.state.forecast.globalUpdate = false, 5000);
                 this.$store.state.forecast.globalProgress = false;
                 this.$store.state.forecast.globalerrorSave = false;
                 this.timeData.forEach((timeEntry) => {
                    if (timeEntry.released === false) {
                        this.$store.state.qtime.released = false;
                }
                })
               if(this.timeData.length>0){
                        if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){                           
                            if(this.saveFlagValue == false){
                                this.saveAll(currentItemId);
                            }
                            else{
                                console.log("Ignoring autosave since already a save is in progress");
                            }
                        }
                        else if(this.monthUnreleasedFlag && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                            this.saveAll(currentItemId);
                        }
                        
                    }
            },
            TimeValueChanged:function(currentItemId){
                this.enableoverlapmsg = false;
                  this.enableAbscmsg = false;
                  this.enabletimelimitmsg = false;
                 setTimeout(() => this.$store.state.forecast.globalUpdate = false, 5000);
                 this.$store.state.forecast.globalProgress = false;
                 this.$store.state.forecast.globalerrorSave = false;
                 this.timeData.forEach((timeEntry) => {
                    if (timeEntry.released === false) {
                        this.$store.state.qtime.released = false;
                }
                })

               if(this.timeData.length>0){
                        if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                            
                            if(this.saveFlagValue == false){
                                this.saveAll(currentItemId);
                            }
                            else{
                                console.log("Ignoring autosave since already a save is in progress");
                            }
                        }else if(this.monthUnreleasedFlag && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                            this.saveAll(currentItemId);
                        }
                        else{
                            this.enabletimelimitmsg = false;
                        }
                        
                        
                    }
                    
            },
            dateRangeOverlaps: function (a_start, a_end, b_start, b_end) {
                if (a_start < b_start && b_start < a_end) return true; // b starts in a
                if (a_start < b_end   && b_end   < a_end) return true; // b ends in a
                if (b_start <  a_start && a_end   <  b_end) return true; // a in b
                if (a_start == b_start && a_end == b_end) return true; // time entries are same
                return false;
            },
            multipleDateRangeOverlaps: function (timeEntries) {
                let i = 0, j = 0;
                let timeIntervals = timeEntries.filter(entry => entry.from != null && entry.to != null && entry.from.length === 8 && entry.to.length === 8);

                if (timeIntervals != null && timeIntervals.length > 1)
                for (i = 0; i < timeIntervals.length - 1; i += 1) {
                    for (j = i + 1; j < timeIntervals.length; j += 1) {
                        if (
                        this.dateRangeOverlaps(
                    new Date('1970-01-01T' + timeIntervals[i].from).getTime(), new Date('1970-01-01T' + timeIntervals[i].to).getTime(),
                    new Date('1970-01-01T' + timeIntervals[j].from).getTime(), new Date('1970-01-01T' + timeIntervals[j].to).getTime()
                            )
                        ) {
                            //this.overlapSaveDeniedModal = true;
                            this.overlapError = true;
                            this.enableoverlapmsg = true;
                            this.$store.state.forecast.globalUpdate = false;
                            return true;
                        }
                    }
                }
                return false;
            }

        },
        updated() {
            if (this.checkedCount === 0) {
                this.allChecked = false;
                $('.clear-checkbox').prop('checked',false);
            }
            this.calculateTotalHours();      
        },
        async mounted() {
            this.calculateTotalHours();
            this.unreleasedMonth();
            this.internalPositionTimes();
        },
        watch: {
            checkedCount: function (value) {
                if (value > 0 && value === this.timeData.length) {
                    this.allChecked = true;
                } else {
                    this.allChecked = false;
                }
            },
            timeData:function(){
                 this.enableoverlapmsg = false;
                 this.enableAbscmsg = false;
                 this.enabletimelimitmsg = false;
                 setTimeout(() => this.$store.state.forecast.globalUpdate = false, 5000);
                 this.$store.state.forecast.globalProgress = false;
                 this.$store.state.forecast.globalerrorSave = false;
                    if(this.timeData.length>0){
                        if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                            if(this.saveFlagValue == false && !this.enabletimelimitmsg){
                                this.saveAll();
                                this.enabletimelimitmsg = false;
                            }
                            else if(this.monthUnreleasedFlag){
                                this.saveAll();
                            }
                            else{
                                console.log("Ignoring autosave since already a save is in progress");
                            }
                        }
                        
                    }
                
            }
        },
        created() {
            this.requestApis();
           
            document.body.classList.add('qtime-body');
            
             moment.locale('en-US', {
                 week: {
                        dow: 1
                    }
             });

            $(document).on('click', '.ant-time-picker', function () {
                $('input.ant-time-picker-input').removeClass('active-tab');
                $(this).find('input.ant-time-picker-input').addClass('active-tab');
            });

             $(document).on('click', '#date-id-copy', function () {
                 document.getElementById('date-copy-picker').getElementsByTagName("input")[0].click();
            });                    

            $(document).on('keydown', (e) => {
                if (e.which === 9 && $(e.target).hasClass('ant-time-picker-panel-input')) {
                    let next = $('input.ant-time-picker-input.active-tab').parent().find('input.ant-time-picker-input');
                    if (next.length > 0) {
                        next.focus();
                    }
                }
            });

            /*window.onbeforeunload = function () {
                //if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                     return true;
               // }
              
            }*/
            window.addEventListener('beforeunload', (event) => {
                // Chrome requires returnValue to be set.
                if (!this.released && JSON.stringify(this.timeData) != JSON.stringify(this.timeDataClone)){
                     var e = e || window.event;

                    // For IE and Firefox
                    if (e) {
                        e.returnValue = 'true';
                    }

                    // For Safari
                    return 'true';
                }
                
            });
        },
    };
</script>
<style scoped>
    .btn-disabled {
        opacity: 0.5; /* Adjust the styling as per your requirements */
        pointer-events: none;
    }
    .container {
        max-width: 1430px;
    }

    #date-id-picker,
    #date-id-copy {
        position: relative;
    }

    /* For small devices only */
    @media screen and (max-width: 690px) {
        .container {
            padding-right: 0;
            min-width: 800px;
        }
    }

    .cta-btn:focus,
    .cta-btn:hover {
        text-decoration: none !important;
    }

     .qtime-body .table-row-header .booking-node .custom-checkbox{
        padding-top: 0;
        height: 21px;
        align-self: center;
        margin-bottom: 7px;
    }
    p.disable-validation-msg {
        display: none;
    }

    span.progress-tag img{margin-right: 10px;vertical-align: text-bottom;}
    span.progress-tag {color:#003656;margin-right:10px;vertical-align: middle;line-height: 18px;}
    span.progress-tag.progress-cancelled {color:#ff0000; margin-right:10px;}

    .validation-msg-bt{
        margin: 10px 0;
        color:#ff0000;
    }
    a.disable-icon{
        display: none;
    }  
 .hidden-div {
        opacity: 0;
    }
</style>